import { Box, Button, Flex } from "@chakra-ui/react"
import { useState } from "react"
import AdLayout from "../AdLayout"
import SideInfo from "../Extra/SideInfo"
import Memory from "./Memory/AppMemory"
import Quiz from './Quiz/AppJuego'
import * as React from "react";
import {  Image, Badge, Text, Core} from "@chakra-ui/core";
import { Container, Spacer } from "@chakra-ui/react"
import { MdStar } from "react-icons/md";

const Juegos = () => {
    return <>
        <AdLayout BoxA={tryut} BoxC={tryut} BoxB={JuegoInf}/>
    </>
}

const JuegoInf = () => {

    const [selectedGame, setSelectedGame] = useState('none')

    return <Box
        height="100%"
    >   
        t
        <Flex 
            justifyContent="center"
        >

            <JuegoN 
                text="Juego de compatibilidad"
                onClick={()=>{setSelectedGame('memorama')}}
            />

            <JuegoN 
                text="Quiz de donación"
                onClick={()=>{setSelectedGame('quiz')}}
            />
				

        </Flex>

        {selectedGame === 'quiz' &&
            <Box
                height="100%"
            >
                <Quiz/>
            </Box>
        }

        {selectedGame === 'memorama' &&
            <Box
                height="100%"
            >
                <Memory/>
            </Box>
        }

    </Box>

}

  
const JuegoN = ({text, onClick}) => {

    return <Button
        mx="3%"
        p="3%"
        py="4%"
        bg="zred.600"
        border="1px solid"
        borderColor="zred.100"
        borderRadius="16"
        onClick={onClick}
    >
        {text}
    </Button>
}

export const AdDefault = () => {
    return <Box
        m="10"
        bg="zred.100"
    >
        Debería de ser un anuncio, o algo así. no sé!
    </Box>
}

export const tryut = () => {
	
	return <Flex>
				  <Box p="5" maxW="320px" borderWidth="1px" >
				      <Image borderRadius="md" src="https://scontent.fgdl10-1.fna.fbcdn.net/v/t1.6435-9/119444375_735118150372710_5080122446747634113_n.png?_nc_cat=108&ccb=1-3&_nc_sid=6e5ad9&_nc_ohc=qFlK59umj8EAX-OUo9P&_nc_ht=scontent.fgdl10-1.fna&oh=00a48fab2b0d71e51374a62ed6010407&oe=60D68CBB" />
				      <Flex align="baseline" mt={2}>
				        
				        <Text
				          ml={2}
				          textTransform="uppercase"
				          fontSize="sm"
				          fontWeight="bold"
				          color="rgb(255, 255, 255)"
				        >
				          Te invitamos &bull; No Faltes!
				        </Text>
				      </Flex>
				      <Text mt={2} fontSize="xl" fontWeight="semibold" lineHeight="short">
				        Modern, Chic Penthouse with Mountain, City & Sea Views
				      </Text>
				      <Text mt={2}>$119/night</Text>
				      <Flex mt={2} align="center">
				        <Box as={MdStar} color="orange.400" />
				        <Text ml={1} fontSize="sm">
				          <b>4.84</b> (190)
				        </Text>
				      </Flex>
			    </Box>
		</Flex>
}


export default Juegos
